import PopoverListItem from './PopoverListItem';

export default PopoverListItem;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/PopoverListItem/index.js